import styled from 'styled-components'
import useTheme from 'hooks/useTheme'
import { palette } from 'views/Home/colors'

const BodyWrapper = styled.div<{ children?: React.ReactNode; $bg: string; $border: string }>`
  border-radius: 20px;
  max-width: 480px;
  width: 100%;
  z-index: 1;
  background: ${({ $bg }) => $bg};
  border: 1px solid ${({ $border }) => $border};
  box-shadow: 0 8px 40px rgba(10, 26, 51, 0.14);
  overflow: hidden;
`

export default function AppBody({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme()
  const p = palette(theme.isDark)
  return (
    <BodyWrapper $bg={p.card} $border={p.border}>
      {children}
    </BodyWrapper>
  )
}
